import { Outlet } from 'react-router-dom';
import { Bike, CalendarDays, MapPin, UserRound } from 'lucide-react';
import { AppShell, type NavItem } from '~/components/layout/app-shell';

const ITEMS: NavItem[] = [
  { to: '/mon-compte', label: 'Mes interventions', icon: CalendarDays, end: true },
  { to: '/mon-compte/velos', label: 'Mes cycles', icon: Bike },
  { to: '/mon-compte/adresses', label: 'Mes adresses', icon: MapPin },
  { to: '/mon-compte/profil', label: 'Ma fiche', icon: UserRound },
];

export function ClientLayout() {
  return (
    <AppShell items={ITEMS} title="Mon espace">
      <Outlet />
    </AppShell>
  );
}
